// extracted by mini-css-extract-plugin
export var bgGradientPpc = "index-module--bg-gradient-ppc--8beb1";
export var bulletsHeroPpc = "index-module--bullets-hero-ppc--f0796";
export var heading = "index-module--heading--3324d";
export var headingContainer = "index-module--heading-container--649f5";
export var highlight = "index-module--highlight--4a2cd";
export var highlightLine = "index-module--highlight-line--752c4";
export var image1 = "index-module--image-1--a6d4d";
export var image2 = "index-module--image-2--86cb8";
export var imageContainer = "index-module--image-container--6b704";